import { allMissionsStore, missionsStore } from 'app/redux/slices/missions.slice';
import { RootState } from '../../rootReducer';

export function selectDetailedMissions(state: RootState) {
    return state[missionsStore][allMissionsStore];
}
